var map = {
	"./ai/2018.json": 2532,
	"./ai/2019.json": 5262,
	"./ai/2020.json": 2644,
	"./ai/2021.json": 854,
	"./ai/2022.json": 8554,
	"./ai/2023.json": 1535,
	"./ai/2024.json": 6417,
	"./ai/2025.json": 3142,
	"./ai/blog.json": 5115,
	"./ai/categories.json": 4175,
	"./ai/follow.json": 8967,
	"./ai/years.json": 3948,
	"./android/2017.json": 8333,
	"./android/2018.json": 5391,
	"./android/2019.json": 1297,
	"./android/2020.json": 828,
	"./android/2021.json": 7845,
	"./android/2022.json": 5278,
	"./android/2023.json": 4748,
	"./android/2024.json": 1286,
	"./android/2025.json": 6106,
	"./android/blog.json": 8946,
	"./android/follow.json": 4263,
	"./android/years.json": 3652,
	"./arvr/2018.json": 9439,
	"./arvr/2019.json": 3963,
	"./arvr/2020.json": 4553,
	"./arvr/2021.json": 141,
	"./arvr/2022.json": 3860,
	"./arvr/2023.json": 9088,
	"./arvr/2024.json": 694,
	"./arvr/2025.json": 90,
	"./arvr/blog.json": 1321,
	"./arvr/follow.json": 5148,
	"./arvr/years.json": 5878,
	"./backend/2025.json": 7676,
	"./backend/blog.json": 1332,
	"./backend/follow.json": 9123,
	"./backend/years.json": 9479,
	"./biotech/2017.json": 1015,
	"./biotech/2018.json": 3684,
	"./biotech/2019.json": 4712,
	"./biotech/2020.json": 8294,
	"./biotech/2021.json": 9722,
	"./biotech/2022.json": 3019,
	"./biotech/2023.json": 6274,
	"./biotech/2024.json": 7678,
	"./biotech/2025.json": 6794,
	"./biotech/blog.json": 6192,
	"./biotech/follow.json": 5084,
	"./biotech/years.json": 6895,
	"./blockchain/2017.json": 9096,
	"./blockchain/2018.json": 9806,
	"./blockchain/2019.json": 1594,
	"./blockchain/2020.json": 5818,
	"./blockchain/2021.json": 4253,
	"./blockchain/2022.json": 4195,
	"./blockchain/2023.json": 9874,
	"./blockchain/2024.json": 7622,
	"./blockchain/2025.json": 9444,
	"./blockchain/blog.json": 8359,
	"./blockchain/follow.json": 1027,
	"./blockchain/years.json": 3656,
	"./creativedesign/2023.json": 204,
	"./creativedesign/2024.json": 1963,
	"./creativedesign/2025.json": 2910,
	"./creativedesign/blog.json": 2286,
	"./creativedesign/creativedesignblogs/2023.json": 5445,
	"./creativedesign/creativedesignblogs/2024.json": 4856,
	"./creativedesign/creativedesignblogs/2025.json": 5786,
	"./creativedesign/follow.json": 861,
	"./creativedesign/years.json": 3438,
	"./cybersecurity/2017.json": 1473,
	"./cybersecurity/2018.json": 7492,
	"./cybersecurity/2019.json": 2063,
	"./cybersecurity/2020.json": 8626,
	"./cybersecurity/2021.json": 4003,
	"./cybersecurity/2022.json": 6823,
	"./cybersecurity/2023.json": 4152,
	"./cybersecurity/2024.json": 5300,
	"./cybersecurity/2025.json": 1782,
	"./cybersecurity/blog.json": 5597,
	"./cybersecurity/follow.json": 3552,
	"./cybersecurity/years.json": 8594,
	"./devops/2017.json": 5021,
	"./devops/2018.json": 7803,
	"./devops/2019.json": 78,
	"./devops/2020.json": 8141,
	"./devops/2021.json": 3178,
	"./devops/2022.json": 1133,
	"./devops/2023.json": 7925,
	"./devops/2024.json": 9466,
	"./devops/2025.json": 4980,
	"./devops/blog.json": 1507,
	"./devops/follow.json": 1410,
	"./devops/years.json": 5335,
	"./embedded-system/2025.json": 8226,
	"./embedded-system/blog.json": 7644,
	"./embedded-system/follow.json": 3095,
	"./embedded-system/years.json": 6219,
	"./foss/2025.json": 4439,
	"./foss/blog.json": 4165,
	"./foss/follow.json": 5038,
	"./foss/years.json": 5825,
	"./frontend/2017.json": 7535,
	"./frontend/2018.json": 56,
	"./frontend/2019.json": 9743,
	"./frontend/2020.json": 3247,
	"./frontend/2021.json": 6843,
	"./frontend/2022.json": 7708,
	"./frontend/2023.json": 5403,
	"./frontend/2024.json": 252,
	"./frontend/2025.json": 5179,
	"./frontend/blog.json": 2409,
	"./frontend/follow.json": 6573,
	"./frontend/years.json": 9196,
	"./home.json": 5993,
	"./ios/2017.json": 670,
	"./ios/2018.json": 757,
	"./ios/2019.json": 4378,
	"./ios/2020.json": 4060,
	"./ios/2021.json": 6947,
	"./ios/2022.json": 7655,
	"./ios/2023.json": 7753,
	"./ios/2024.json": 5594,
	"./ios/2025.json": 5023,
	"./ios/blog.json": 5481,
	"./ios/follow.json": 6026,
	"./ios/years.json": 2666,
	"./iot/2024.json": 1635,
	"./iot/2025.json": 8419,
	"./iot/blog.json": 9207,
	"./iot/follow.json": 5973,
	"./iot/years.json": 7023,
	"./marketing/2025.json": 9624,
	"./marketing/blog.json": 5188,
	"./marketing/follow.json": 4112,
	"./marketing/years.json": 674,
	"./pm/2023.json": 9661,
	"./pm/2024.json": 2949,
	"./pm/2025.json": 633,
	"./pm/blog.json": 9307,
	"./pm/follow.json": 3869,
	"./pm/product-management-blogs/2023.json": 719,
	"./pm/product-management-blogs/2024.json": 9855,
	"./pm/product-management-blogs/2025.json": 5621,
	"./pm/years.json": 9257,
	"./qa/2017.json": 1840,
	"./qa/2018.json": 4131,
	"./qa/2019.json": 3913,
	"./qa/2020.json": 251,
	"./qa/2021.json": 4538,
	"./qa/2022.json": 5658,
	"./qa/2023.json": 8063,
	"./qa/2024.json": 4894,
	"./qa/2025.json": 4065,
	"./qa/blog.json": 176,
	"./qa/follow.json": 3859,
	"./qa/years.json": 4742,
	"./quantum-computing/2017.json": 2392,
	"./quantum-computing/2018.json": 2625,
	"./quantum-computing/2019.json": 6959,
	"./quantum-computing/2020.json": 942,
	"./quantum-computing/2021.json": 2072,
	"./quantum-computing/2022.json": 7922,
	"./quantum-computing/2023.json": 3969,
	"./quantum-computing/2024.json": 7875,
	"./quantum-computing/2025.json": 6163,
	"./quantum-computing/blog.json": 1948,
	"./quantum-computing/follow.json": 9769,
	"./quantum-computing/years.json": 1523,
	"./robotics-automation/2025.json": 3818,
	"./robotics-automation/blog.json": 67,
	"./robotics-automation/follow.json": 2451,
	"./robotics-automation/years.json": 7970,
	"./uiux/2023.json": 4972,
	"./uiux/2024.json": 1839,
	"./uiux/2025.json": 4983,
	"./uiux/blog.json": 5726,
	"./uiux/follow.json": 992,
	"./uiux/uiuxblogs/2023.json": 4447,
	"./uiux/uiuxblogs/2024.json": 6759,
	"./uiux/uiuxblogs/2025.json": 8094,
	"./uiux/years.json": 2980,
	"./web/2017.json": 6129,
	"./web/2018.json": 230,
	"./web/2019.json": 8052,
	"./web/2020.json": 5006,
	"./web/2021.json": 2964,
	"./web/2022.json": 4184,
	"./web/blog.json": 6510,
	"./web/follow.json": 482,
	"./web/years.json": 4237
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2147;
module.exports = webpackAsyncContext;